import { render, staticRenderFns } from "./setor.vue?vue&type=template&id=84c4957a&"
import script from "./setor.vue?vue&type=script&lang=js&"
export * from "./setor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports